import { Button } from '@/shared/ui/button';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 hover:bg-transparent hover:text-foreground/80 px-2"
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm">
        {language === 'en' ? 'EN' : '中文'}
      </span>
    </Button>
  );
}
